import {TerminalSearchModel} from "../terminal-search.model";
import {Component, Injector} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {TerminalSearchPageComponent} from "../terminal-search-page/terminal-search-page.component";
import {
    AbstractSelectSearchControlComponent
} from "../../../framework/entity/search/search-controls/select-search-controls/abstract-select-search-control.component";
import {
    registerSearchControl
} from "../../../framework/entity/search/search-controls/abstract-search-control.component";

@Component({
    selector: "wbo-terminal-multi-select-search-control",
    templateUrl: "../../../framework/entity/search/search-controls/select-search-controls/multi-select-search-control.component.html",
    providers: [
        provideSearchModel(TerminalSearchModel),
        registerSearchControl(TerminalMultiSelectSearchControlComponent)
    ]
})
export class TerminalMultiSelectSearchControlComponent extends AbstractSelectSearchControlComponent<TerminalSearchModel> {
    constructor(model: TerminalSearchModel, injector: Injector) {
        super(model, injector, "name", "name");
        this.extendedSearchComponent = TerminalSearchPageComponent;
    }
}
